'use client';

import { alertTypes } from '@quick/components/Alert/domain';
import { InlineSpinner } from '@quick/components/InlineSpinner';

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './ToasterInners';
import { useToast } from './useToast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        const Icon =
          props.variant === 'promise'
            ? InlineSpinner
            : alertTypes[props.variant ?? 'default'] ?? alertTypes.default;
        return (
          <Toast key={id} {...props}>
            <Icon className="size-6 shrink-0" />
            <div className="grid grow gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
